"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubTypes = exports.setTestSubType = exports.deleteSubType = exports.updateSubType = exports.createSubType = exports.getSubTypes = exports.downloadCutoff = exports.downloadQuestionStatsForm = exports.downloadYigamForm = exports.downloadCutoffForm = exports.downloadStatistics = exports.useGradeCardList = exports.getGradeCard = exports.useScoreStatus = exports.useGradeReport = exports.useTierCutoff = exports.useReportData = exports.useSubmitStatus = exports.useTierCount = exports.getTierCount = exports.useStatistics = exports.useGradesList = exports.useSurveyFrequency = exports.useFeedbackList = exports.useAnswerList = exports.useQuestionList = exports.useAssignmentList = exports.deleteAssignmentList = exports.uploadCutoff = exports.postAssignmentList = exports.postFeedback = exports.postSubmitAnswer = exports.postUpdateAssignmentList = exports.postSurvey = exports.postQuestion = exports.getStatistics = exports.getGrades = exports.markRetakeRounds = exports.getGradeReport = exports.getTierCutoff = exports.getQuestionStats = exports.getReportData = exports.getSubmitStatus = exports.getScoreStatus = exports.getAssignmentList = void 0;
const account_1 = require("../../features/base/account");
const classes_1 = require("../../features/base/classes");
const functions_1 = require("../functions");
const getToken = () => (0, account_1.getAccessToken)(APP.store.getState);
const getAuthorizedRequestOptions = (options) => ({
    ...options,
    headers: {
        Authorization: `Bearer ${getToken()}`,
        ...(options?.headers || {}),
    },
});
const downloadAuthorizedFile = async (url, fallbackFilename) => {
    const response = await fetch(url, getAuthorizedRequestOptions({ method: 'GET' }));
    if (!response.ok) {
        let message = '다운로드 실패';
        try {
            const result = await response.json();
            message = result?.message?.format || result?.format || message;
        }
        catch (error) {
            console.error(error);
        }
        throw new Error(message);
    }
    const disposition = response.headers.get('content-disposition');
    let filename = fallbackFilename;
    if (disposition && disposition.includes('filename=')) {
        let rawFilename = disposition.split('filename=')[1].replace(/['"]/g, '').trim();
        try {
            filename = decodeURIComponent(rawFilename);
        }
        catch {
            filename = rawFilename;
        }
    }
    const blob = await response.blob();
    const urlBlob = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = urlBlob;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(urlBlob);
};
// (테스트 및 과제) 리스트 조회
const getAssignmentList = async (queryString) => {
    const url = `/api/mimac/v1/tests?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.getAssignmentList = getAssignmentList;
// (테스트 및 과제) 질문 조회
const getQuestionList = async (queryString) => {
    const url = `/api/mimac/v1/questions?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (테스트 및 과제) 풀이 조회
const getAnswerList = async (queryString) => {
    const url = `/api/mimac/v1/answers?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (테스트 및 과제) 피드백 조회
const getFeedbackList = async (queryString) => {
    const url = `/api/mimac/v1/feedbacks?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (테스트 및 과제) 설문 빈도 조회
const getSurveyFrequency = async (test_id) => {
    const url = `/api/mimac/v1/tests/${test_id}/frequencies`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
// (테스트 및 과제) 점수 현황 조회
const getScoreStatus = async ({ id, queryString }) => {
    const url = `/api/mimac/v1/tests/${id}/score-status?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getScoreStatus = getScoreStatus;
// (테스트 및 과제) 제출 현황 조회
const getSubmitStatus = async ({ id, queryString }) => {
    const url = `/api/mimac/v1/tests/${id}/submit-status?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getSubmitStatus = getSubmitStatus;
const getReportData = async ({ id, queryString, }) => {
    const url = `/api/mimac/v1/tests/${id}/report-data${queryString ? `?${queryString}` : ''}`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({ method: 'GET' }));
};
exports.getReportData = getReportData;
// 문항별 분석 저장본 재조회(2026-07-29 서버 신설) — report-data 응답 형식을 재활용하며
// subject_item / number / rating / rank / choice1~choice5 만 사용한다(서버 안내).
// 응답 래핑 형태(question_stats/items/배열)는 mapQuestionStatsToRows 가 방어적으로 수용.
const getQuestionStats = async (id) => {
    const url = `/api/mimac/v1/tests/${id}/question-stats`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({ method: 'GET' }));
};
exports.getQuestionStats = getQuestionStats;
const getTierCutoff = async (id, member_id) => {
    const query = member_id ? `?member_id=${encodeURIComponent(member_id)}` : '';
    const url = `/api/mimac/v1/tests/${id}/tier-cutoff${query}`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({ method: 'GET' }));
};
exports.getTierCutoff = getTierCutoff;
// (성적표) 회차별 성적 조회.
// queryString 파라미터: class_id / test_id / report_type / ref_test_id
//  - ref_test_id: 기준 테스트 id. 서버가 그 테스트의 성적표(상세) 유형과 동일한 테스트만 내려준다.
//    report_type(gmk/yigam/etc) 만으로는 기타(etc)의 상세유형(예: 홍모, K+)이 구분되지 않아
//    서로 다른 상세유형의 회차가 한 그래프에 섞이던 문제 때문에 서버가 신설(2026-08). 성적표 호출부는 항상 함께 전송한다.
const getGradeReport = async ({ id, queryString, }) => {
    const url = `/api/mimac/v1/members/${id}/grade-report${queryString ? `?${queryString}` : ''}`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({ method: 'GET' }));
};
exports.getGradeReport = getGradeReport;
/**
 * (성적표) 재응시 회차 표기 — ref_test_id 로 조회한 회차별 성적에만 쓴다.
 * 서버가 회차 > 시간 순으로 정렬해 내려주므로, 같은 회차가 연달아 오면 뒤쪽(나중에 등록된 재응시)을 "N회차(재)" 로 표기한다.
 *  - round 가 0/없음이면 회차 개념이 없으므로 표기하지 않는다.
 *  - 이전 항목과 round 가 같을 때만(첫 응시는 "N회차" 그대로).
 * 같은 회차 안의 순서를 유지해야 하므로 호출 전 정렬은 안정 정렬(Array.prototype.sort)로 round 만 비교할 것.
 * (2026-10 DSL00109 12주차 단어 TEST — 잘못된 시험지로 본 기존 12회차 + 같은 12회차로 다시 등록한 재응시)
 */
const markRetakeRounds = (items) => items.map((item, index) => {
    const prev = index > 0 ? items[index - 1] : undefined;
    const isRetake = !!item.round && prev?.round === item.round;
    return isRetake ? { ...item, round_label: `${item.round}회차(재)` } : item;
});
exports.markRetakeRounds = markRetakeRounds;
// (테스트 및 과제) 성적 조회
const getGrades = async (queryString) => {
    const url = `/api/mimac/v1/grades?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getGrades = getGrades;
// (테스트 및 과제) 성적 조회
const getStatistics = async ({ test_id, queryString, }) => {
    const url = `/api/mimac/v1/tests/${test_id}/statistics?${queryString}`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getStatistics = getStatistics;
// (테스트 및 과제) 질문 출제 등록
const postQuestion = async (data) => {
    const url = `/api/mimac/v1/tests/${data.id}/set-question`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ questions: data.props }),
    });
};
exports.postQuestion = postQuestion;
// (테스트 및 과제) 설문 질문 등록
const postSurvey = async (data) => {
    const url = `/api/mimac/v1/tests/${data.id}/set-question`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({ questions: data.props }),
    });
};
exports.postSurvey = postSurvey;
// (테스트 및 과제) 질문 출제 등록
const postUpdateAssignmentList = async (data) => {
    const url = `/api/mimac/v1/tests/${data.id}/update`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
    });
};
exports.postUpdateAssignmentList = postUpdateAssignmentList;
// 동일 test_id 답안 제출의 단일비행(in-flight) 가드 — 0.06초 간격 중복 발사 원천 차단.
// 진행 중이면 새 fetch 를 만들지 않고 진행 중인 Promise 를 공유 반환한다(reject 금지 설계).
const submitAnswerInFlight = new Map();
// (테스트 및 과제) 질문 출제 등록
const postSubmitAnswer = (data) => {
    // 동기 가드: await 이전에 조회/등록하므로 같은 태스크 내 이중 발화도 차단
    const inFlight = submitAnswerInFlight.get(data.id);
    if (inFlight)
        return inFlight;
    const url = `/api/mimac/v1/tests/${data.id}/submit-answer`;
    const request = (async () => {
        try {
            return await (0, functions_1.fetchData)(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify(data.props),
            });
        }
        finally {
            // 완료(성공/실패) 시 제거 — 이후의 정상 재제출 허용
            submitAnswerInFlight.delete(data.id);
        }
    })();
    submitAnswerInFlight.set(data.id, request);
    return request;
};
exports.postSubmitAnswer = postSubmitAnswer;
// (테스트 및 과제) 피드백 등록
const postFeedback = async (data) => {
    const url = `/api/mimac/v1/tests/${data.id}/feedback-answer`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data.props),
    });
};
exports.postFeedback = postFeedback;
// (테스트 및 과제) 리스트 등록
const postAssignmentList = async (data) => {
    const url = `/api/mimac/v1/tests`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(data),
    });
};
exports.postAssignmentList = postAssignmentList;
const uploadCutoff = async ({ id, file }) => {
    const url = `/api/mimac/v1/tests/${id}/upload-report-data`;
    const formData = new FormData();
    formData.append('file', file);
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({
        method: 'POST',
        body: formData,
    }));
};
exports.uploadCutoff = uploadCutoff;
// (테스트 및 과제) 리스트 삭제
const deleteAssignmentList = async (id) => {
    const url = `/api/mimac/v1/tests/${id}/delete`;
    return (0, functions_1.fetchData)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${getToken()}`,
        },
    });
};
exports.deleteAssignmentList = deleteAssignmentList;
// (테스트 및 과제) 리스트 가져오기
const useAssignmentList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data); // props를 쿼리 문자열로 변환
    return (0, functions_1.useCustomQuery)([`questions_${queryString}`, data], () => (0, exports.getAssignmentList)(queryString));
};
exports.useAssignmentList = useAssignmentList;
// (테스트 및 과제) 질문 가져오기
const useQuestionList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`question_${queryString}`, data], () => getQuestionList(queryString));
};
exports.useQuestionList = useQuestionList;
// (테스트 및 과제) 답변 가져오기
const useAnswerList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)(`answer_${data?.from || data?.test_id}`, () => getAnswerList(queryString));
};
exports.useAnswerList = useAnswerList;
// (테스트 및 과제) 피드백 가져오기
const useFeedbackList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)(['feedback', data], () => getFeedbackList(queryString));
};
exports.useFeedbackList = useFeedbackList;
// (테스트 및 과제) 설문 빈도 조회
const useSurveyFrequency = (test_id) => {
    return (0, functions_1.useCustomQuery)(`frequencies_${test_id}`, () => getSurveyFrequency(test_id));
};
exports.useSurveyFrequency = useSurveyFrequency;
// (테스트 및 과제) 성적 가져오기
const useGradesList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)(`grades_${data.test_id}`, () => (0, exports.getGrades)(queryString));
};
exports.useGradesList = useGradesList;
// (테스트 및 과제) 통계 가져오기
const useStatistics = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)(`statistics_${queryString}`, () => (0, exports.getStatistics)({ test_id: data.test_id, queryString }));
};
exports.useStatistics = useStatistics;
// (테스트) 등급별 인원 수 조회 — 성적표(성적 데이터) 입력분 기준.
// 서버는 존재하는 등급만 내려준다: result.items = [{ tier, count } ...] (미입력 시 빈 배열)
const getTierCount = async ({ test_id }) => {
    const url = `/api/mimac/v1/tests/${test_id}/tier-count`;
    return (0, functions_1.fetchData)(url);
};
exports.getTierCount = getTierCount;
const useTierCount = (data) => {
    return (0, functions_1.useCustomQuery)(`tier_count_${data?.test_id}`, () => (0, exports.getTierCount)({ test_id: data.test_id }));
};
exports.useTierCount = useTierCount;
// (테스트 및 과제) 점수 현황 가져오기
const useSubmitStatus = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`submit_${queryString}`, data], () => (0, exports.getSubmitStatus)({ id: data.id, queryString }));
};
exports.useSubmitStatus = useSubmitStatus;
const useReportData = (data) => {
    const queryString = (0, functions_1.objectToQueryString)({ member_id: data?.member_id });
    return (0, functions_1.useCustomQuery)([`report_data_${data?.id}_${data?.member_id}`, data], () => (0, exports.getReportData)({ id: data?.id, queryString }));
};
exports.useReportData = useReportData;
const useTierCutoff = (id, member_id) => {
    return (0, functions_1.useCustomQuery)([`tier_cutoff_${id}_${member_id}`, id, member_id], () => (0, exports.getTierCutoff)(id || '', member_id));
};
exports.useTierCutoff = useTierCutoff;
const useGradeReport = (data) => {
    const queryString = (0, functions_1.objectToQueryString)({
        test_id: data?.test_id,
        class_id: data?.class_id,
        report_type: data?.report_type,
        ref_test_id: data?.ref_test_id,
    });
    return (0, functions_1.useCustomQuery)([`grade_report_${data?.id}_${queryString}`, data], () => (0, exports.getGradeReport)({ id: data?.id, queryString }));
};
exports.useGradeReport = useGradeReport;
// (테스트 및 과제) 점수 현황 가져오기
const useScoreStatus = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`score_${data}`, data], () => (0, exports.getScoreStatus)({ id: data.id, queryString }));
};
exports.useScoreStatus = useScoreStatus;
// 성적표 API 조회
const getGradeCard = async (id, queryString) => {
    const class_id = (0, classes_1.getClassesId)();
    const url = `/api/mimac/v1/members/${id}/test-report?${queryString}&class_id=${class_id}`; // API 엔드포인트 생성`; // API 엔드포인트 생성
    return (0, functions_1.fetchData)(url);
};
exports.getGradeCard = getGradeCard;
const useGradeCardList = (data) => {
    const queryString = (0, functions_1.objectToQueryString)(data);
    return (0, functions_1.useCustomQuery)([`gradeCard_${data}`, data], () => (0, exports.getGradeCard)(data.id, queryString));
};
exports.useGradeCardList = useGradeCardList;
// 과제 및 테스트 통계 다운로드
const downloadStatistics = async (test_id) => {
    const url = `/api/mimac/v1/tests/${test_id}/download`;
    return downloadAuthorizedFile(url, 'downloaded_file.zip');
};
exports.downloadStatistics = downloadStatistics;
// 성적데이터 양식 다운로드 — test_id 를 넘기면 서버가 해당 테스트의 과목/유형에 맞는 양식을 반환.
const downloadCutoffForm = async (testId) => {
    const url = testId
        ? `/api/mimac/v1/tests/download-cutoff-form?test_id=${encodeURIComponent(testId)}`
        : `/api/mimac/v1/tests/download-cutoff-form`;
    await downloadAuthorizedFile(url, 'cutoff_template.xlsx');
};
exports.downloadCutoffForm = downloadCutoffForm;
const downloadYigamForm = async () => {
    await downloadAuthorizedFile(`/api/mimac/v1/tests/download-yigam-form`, 'yigam_template.xlsx');
};
exports.downloadYigamForm = downloadYigamForm;
const downloadQuestionStatsForm = async () => {
    await downloadAuthorizedFile(`/api/mimac/v1/tests/download-question-stats-form`, 'question_stats_template.xlsx');
};
exports.downloadQuestionStatsForm = downloadQuestionStatsForm;
const downloadCutoff = async (id) => {
    const url = `/api/mimac/v1/tests/${id}/download-report-data`;
    return downloadAuthorizedFile(url, `cutoff-data-${id}.xlsx`);
};
exports.downloadCutoff = downloadCutoff;
// (구 fetchCutoffBlob 삭제 — download-report-data 기반 표 복원 폐기. 복원은
//  question-stats(문항별 분석) + tier-cutoff(예상등급컷) API 사용. 2026-07-29)
const getSubTypes = async (queryString) => {
    const url = `/api/mimac/v1/tests/sub-types${queryString ? `?${queryString}` : ''}`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({ method: 'GET' }));
};
exports.getSubTypes = getSubTypes;
const createSubType = async (data) => {
    const url = `/api/mimac/v1/tests/sub-types`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }));
};
exports.createSubType = createSubType;
const updateSubType = async (id, data) => {
    const url = `/api/mimac/v1/tests/sub-types/${id}/update`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }));
};
exports.updateSubType = updateSubType;
const deleteSubType = async (id) => {
    const url = `/api/mimac/v1/tests/sub-types/${id}/delete`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
    }));
};
exports.deleteSubType = deleteSubType;
const setTestSubType = async (testId, subTypeId) => {
    const url = `/api/mimac/v1/tests/${testId}/set-sub-type`;
    return (0, functions_1.fetchData)(url, getAuthorizedRequestOptions({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sub_type_id: subTypeId }),
    }));
};
exports.setTestSubType = setTestSubType;
const useSubTypes = (params) => {
    const queryString = (0, functions_1.objectToQueryString)({ offset: params?.offset ?? 0, limit: params?.limit ?? 100 });
    return (0, functions_1.useCustomQuery)([`sub_types_${queryString}`, params], () => (0, exports.getSubTypes)(queryString));
};
exports.useSubTypes = useSubTypes;
